<template>
  <div>
    <div style="width: 124px;display: inline-block">{{ $t('publishEdit.WarehouseName') }}</div>
    <el-popover
      v-if="submitMode !== 'edit'"
      placement="bottom"
      width="450"
      trigger="click"
      title="Batch settings"
      v-model="visible">
      <div style="padding:10px;padding-left:20px">
        <div class="f--c">
          <div style="margin-right:10px">{{ $t('publishEdit.WarehouseName') }}</div>
          <el-select v-model="warehouseId" class="warehouse-list">
            <el-option v-for="item in ttWarehouseList" :key="item.warehouseId" :label="item.warehouseName" :value="item.warehouseId"></el-option>
          </el-select>
        </div>
        <div style="text-align:right;margin-top:20px">
          <el-button @click="btnClick('cancel')">{{$t('publishEdit.cancel')}}</el-button>
          <el-button type="primary" @click="btnClick('confirm')">{{$t('publishEdit.confirm')}}</el-button>
        </div>
      </div>
      <i class="el-icon-edit" style="cursor: pointer;font-size: 15px" slot="reference"></i>
    </el-popover>
  </div>
</template>

<script>
export default {
  props: {
    submitMode: {
      type: String,
      default: () => ''
    },
    ttWarehouseList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      warehouseId: undefined,
      visible: false
    }
  },
  created() {
    this.warehouseId = this.ttWarehouseList.find(item => item.isDefault).warehouseId
  },
  methods: {
    btnClick(type) {
      if (type === 'confirm') {
        if (!this.warehouseId) return
        this.$emit('batch', this.warehouseId)
      }
      this.visible = false
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
